import { gql } from 'graphql-tag';

export const GET_TAX_ACCOUNTS = gql`
  query Id2f96c8bf4bdb3d2735b9c5ae43982bed(
    $companyId: ID!
    $filter: TaxAccountFilter
  ) {
    __typename
  }
`;
